import React from "react";
import { Link } from "react-router-dom";
import { useSEO } from "@/lib/seo";

const Block = ({ title, children }) => (
  <section className="mt-12">
    <h2 className="font-display font-black text-2xl md:text-3xl uppercase text-ink leading-none">{title}</h2>
    <div className="mt-4 prose-editorial text-lg">{children}</div>
  </section>
);

export default function Confidentialite() {
  useSEO({
    title: "Politique de confidentialité",
    description: "Politique de confidentialité de Contre-épreuve : données collectées, hébergement, finalités et droits des personnes.",
  });
  return (
    <div className="mx-auto max-w-3xl px-5 md:px-8 py-14 md:py-20">
      <header>
        <p className="text-orange font-bold text-sm uppercase tracking-wide mb-4">Confidentialité</p>
        <h1 className="font-display font-black text-4xl sm:text-5xl md:text-6xl uppercase leading-[0.95] text-ink break-words">
          Politique de confidentialité
        </h1>
      </header>

      <Block title="Données collectées">
        <p>
          Contre-épreuve collecte uniquement les données que vous transmettez volontairement au moyen
          des formulaires du site : le formulaire de contact, le formulaire de proposition de
          contribution (avec pièce jointe facultative) et le champ d'inscription permettant d'être
          prévenu du lancement. Aucune donnée n'est vendue ni cédée à des tiers à des fins
          commerciales.
        </p>
      </Block>

      <Block title="Hébergement et traitement">
        <p>
          Le site est un site statique hébergé par Netlify. Les données saisies dans les formulaires
          sont transmises et conservées via le service de formulaires de l'hébergeur, qui agit comme
          sous-traitant. Elles sont accessibles uniquement à la rédaction.
        </p>
        <p>
          Les données sont conservées le temps nécessaire au traitement de la demande, puis
          supprimées. L'adresse fournie pour être prévenu du lancement est conservée jusqu'à l'envoi
          du message d'annonce, puis supprimée.
        </p>
      </Block>

      <Block title="Finalités">
        <p>
          Les informations transmises servent exclusivement à traiter votre demande, à répondre à vos
          messages, à examiner une éventuelle proposition de contribution et, pour l'inscription au
          lancement, à envoyer un unique message d'annonce. Contre-épreuve ne gère aucune lettre
          d'information régulière.
        </p>
      </Block>

      <Block title="Cookies et mesure d'audience">
        <p>
          Le site n'utilise ni cookie de mesure d'audience, ni traceur publicitaire, ni compteur de
          popularité. Aucun profil de navigation n'est constitué.
        </p>
      </Block>

      <Block title="Vos droits">
        <p>
          Conformément au Règlement général sur la protection des données (RGPD), vous disposez d'un
          droit d'accès, de rectification et de suppression de vos données. Pour l'exercer, écrivez à{" "}
          <a href="mailto:contact@contre-epreuve.fr">contact@contre-epreuve.fr</a> ou utilisez la page{" "}
          <Link to="/contact">Contact</Link>.
        </p>
      </Block>
    </div>
  );
}
